import domready from 'domready'
// import { device } from './utils/plattform'
// import {MenuClass} from './components/menu/index'
import swiper from './components/swiper/SwiperView'
import product from './components/product/productView'
import effects from './components/effects/effectsView'
import scrollreveal from './components/effects/scrollReveal'
import formupload from './components/form/formView'

function startApp() {
  swiper.init()
  product.init()
  effects.init()
  scrollreveal.init()
  formupload.init()

  // const menu = new MenuClass()
  // menu.init()
}

domready(() => {
  startApp()
})



// WEBPACK FOOTER //
// ./app/main.js